import React, { useState, useEffect } from 'react';
import { Link, NavLink } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  
  const handleDragStart = (e: React.DragEvent) => {
    e.preventDefault();
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  // Handle scroll detection for transparent header
  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const shouldBeScrolled = scrollTop > 50;
      
      // Debug logging for mobile course detail page
      if (window.innerWidth <= 768 && window.location.pathname.includes('/courses/')) {
        console.log('Mobile Course Detail - ScrollY:', scrollTop, 'IsScrolled:', shouldBeScrolled);
      }
      
      setIsScrolled(shouldBeScrolled);
    };

    // Set initial state
    handleScroll();

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // Close mobile menu on window resize
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768) {
        setIsMobileMenuOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // Close mobile menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as HTMLElement;
      const mobileNav = document.querySelector('.mobile-nav');
      const hamburgerButton = document.querySelector('.hamburger-menu');
      
      if (isMobileMenuOpen && 
          mobileNav && 
          !mobileNav.contains(target) && 
          hamburgerButton && 
          !hamburgerButton.contains(target)) {
        setIsMobileMenuOpen(false);
      }
    };

    if (isMobileMenuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isMobileMenuOpen]);

  return (
    <header className={`header ${isScrolled ? 'scrolled' : 'transparent'}`} data-debug="Main Header" data-section="header">
      <div className="header-container" data-debug="Header Container">
        <div className="logo" data-debug="Logo Container">
          <Link to="/" onDragStart={handleDragStart}>
            <img 
              src="/assets/images/common/mintKitchenLogo.svg" 
              alt="MintKitchen Logo" 
              className="logo-img" 
              draggable="false"
              onLoad={() => console.log('Logo loaded successfully')}
              onError={(e) => {
                console.error('Logo failed to load:', e);
                // Show fallback text
                (e.target as HTMLImageElement).style.display = 'none';
                const fallback = (e.target as HTMLImageElement).nextElementSibling as HTMLElement;
                if (fallback) fallback.style.display = 'inline';
              }}
            />
            <span style={{ 
              color: 'white', 
              fontSize: '24px', 
              fontWeight: 'bold',
              display: 'none'
            }} className="logo-fallback">
              MintKitchen
            </span>
          </Link>
        </div>
        {/* Hamburger Menu Button */}
        <button 
          className="hamburger-menu"
          onClick={toggleMobileMenu}
          aria-label="Toggle navigation menu"
        >
          <span className={`hamburger-line ${isMobileMenuOpen ? 'open' : ''}`}></span>
          <span className={`hamburger-line ${isMobileMenuOpen ? 'open' : ''}`}></span>
          <span className={`hamburger-line ${isMobileMenuOpen ? 'open' : ''}`}></span>
        </button>

        {/* Desktop Navigation */}
        <nav className="nav desktop-nav">
          <ul className="nav-list">
            <li><NavLink to="/" className="nav-link" onDragStart={handleDragStart}>Home</NavLink></li>
            <li><NavLink to="/ki-werkstatt" className="nav-link" onDragStart={handleDragStart}>KI-Werkstatt</NavLink></li>
            <li><NavLink to="/ki-kurse" className="nav-link" onDragStart={handleDragStart}>KI-Kurse</NavLink></li>
            <li><NavLink to="/kontakt" className="nav-link" onDragStart={handleDragStart}>Kontakt</NavLink></li>
          </ul>
        </nav>

        {/* Mobile Navigation */}
        <nav className={`mobile-nav ${isMobileMenuOpen ? 'open' : ''}`}>
          <ul className="mobile-nav-list">
            <li><NavLink to="/" className="mobile-nav-link" onClick={closeMobileMenu} onDragStart={handleDragStart}>Home</NavLink></li>
            <li><NavLink to="/ki-werkstatt" className="mobile-nav-link" onClick={closeMobileMenu} onDragStart={handleDragStart}>KI-Werkstatt</NavLink></li>
            <li><NavLink to="/ki-kurse" className="mobile-nav-link" onClick={closeMobileMenu} onDragStart={handleDragStart}>KI-Kurse</NavLink></li>
            <li><NavLink to="/kontakt" className="mobile-nav-link" onClick={closeMobileMenu} onDragStart={handleDragStart}>Kontakt</NavLink></li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;
